import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSettingsSlice, DEFAULT_NAVBAR_WIDTH_PX } from './settings';
import { GlobalState } from './types';
import { createSelectors } from './utils';

const useGlobalStoreBase = create<GlobalState>()(
  persist(
    (...args) => ({
      ...createSettingsSlice(...args),
    }),
    {
      name: 'portal-store',
      version: 1,
      migrate: (persistedState, version) => {
        const state = (persistedState ?? {}) as Partial<GlobalState>;
        if (version < 1 && state.navbar) {
          state.navbar = { ...state.navbar, width: DEFAULT_NAVBAR_WIDTH_PX };
        }
        return state as GlobalState;
      },
    },
  ),
);

export const useGlobalStore = createSelectors(useGlobalStoreBase);
